@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.error-message {
  display: flex;
  color: @inline-error-message--text-color;
  padding: 4px;
  border-radius: 2px;

  &.error {
    background: @inline-error-message--error--background-color;
  }

  &.warning {
    background: @inline-error-message--warning--background-color;
  }
}

.icon-and-label {
  display: flex;
  margin: 4px;
  flex-direction: row;
  align-items: center;
}

.state-icon {
  height: 16px;
  width: 16px;
}

.children-wrapper {
  width: 100%;
  align-self: center;
  font-size: 12px;
}
